/**
 * Returns the value of a property or nested property within an object based on a dot
 * delimited path.
 *
 * Example:
 *
 * ```javascript
 * const obj = {
 *    information: {
 *       address: {
 *          country: 'United States'
 *       }
 *    }
 * }
 *
 * const path = 'information.address.country'
 *
 * const result = getPropertyValueByPath(obj, path);
 * ```
 *
 * The value of `result` would be 'United States'.
 */
export function getPropertyValueByPath(obj: Record<string, unknown>, path: string): unknown {
  let value: unknown = obj;
  const properties: Array<string> = path?.split('.');

  for (const prop of properties) {
    if (typeof value !== 'object' || value === null) {
      return undefined;
    }
    value = (value as Record<string, unknown>)[prop];

    if (value === undefined) {
      // Property not found
      return undefined;
    }
  }

  return value;
}
